const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
});

export const formatCurrency = (input?: number | null): string => {
  if (input === undefined || input === null) return '$0';
  return USDollar.format(input);
};
